import { Injectable } from '@angular/core';
import { PersistenceService, StorageType } from 'angular-persistence';
import { UserIdleService } from 'angular-user-idle';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { BehaviorSubject, Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';

@Injectable()
export class SessionService {
    private isUserIdleStarted: boolean = false;

    private extendSessionSubject = new ReplaySubject<boolean>(1);
    public extendSession = this.extendSessionSubject.asObservable();

    private customIdleLimitReachedSubject = new BehaviorSubject<boolean>(false);
    public customIdleLimitReached = this.customIdleLimitReachedSubject.asObservable();    

    private sessionUser: any;
    private custom_idle_limit: number = null;

    constructor(
        private storageService: PersistenceService,
        private userIdle: UserIdleService,
    ) { }

    getSessionToken(): string {
        let session_token = this.storageService.get("session_token", StorageType.SESSION);
        return session_token;
    }

    saveSessionToken(token: string) {
        this.storageService.set("session_token", token, { type: StorageType.SESSION });
    }

    setSessionUser(user: any) {
        this.sessionUser = user;
    }

    destroySessionToken() {
        this.storageService.remove('session_token', StorageType.SESSION);
    }

    getOneTimeToken(): string {
        let session_token = this.storageService.get("one_time_token", StorageType.SESSION);
        return session_token;
    }

    saveOneTimeToken(token: string) {
        this.storageService.set("one_time_token", token, { type: StorageType.SESSION });
    }

    startUserIdleService() {
        if (!this.isUserIdleStarted) {
            console.log("startWatching");
            this.userIdle.startWatching();
            this.userIdle.onTimerStart().subscribe(count => {
                 if (count % 60 == 0) console.log("idled timer (sec) / custom idle limit (min): ", {current_count: count, custom_idle_limit: this.custom_idle_limit}); 
                 if (this.custom_idle_limit != null && count > this.custom_idle_limit) {
                    this.userIdle.stopTimer();
                    this.customIdleLimitReachedSubject.next(true);
                 }
            });
            this.userIdle.onTimeout().subscribe(() => {
                console.log("Time Out");
            });
        }
        return this.userIdle;
    }

    onIdleTimerStart() {
        return this.userIdle.onTimerStart();
    }

    onIdleTimeout() {
        return this.userIdle.onTimeout();
    }

    resetUserIdleTimer() {
        this.extendSessionSubject.next(false);
        this.userIdle.resetTimer();
    }

    getUserIdleConfigValues() {
        return this.userIdle.getConfigValue();
    }

    extendAuthSession() {
        this.extendSessionSubject.next(true);
    }

    setCustomIdleLimit(idle_limit: number) {
        this.custom_idle_limit = idle_limit;
    }

    getItemCustomFieldValue(item, field): string {
        if (item.custom_fields) {
            //var custom_fields = JSON.parse(item.json_custom_fields);
            var field = item.custom_fields.find(f => f.CustomFieldName == field);
            if (field) return field.CustomFieldValue;
        }
        return null;
    }

    log(msg?: any, ...optionalParams: any[]) {
        var isVerbose = this.sessionUser && this.getItemCustomFieldValue(this.sessionUser, "Enable Verbose SPA Log") == "Yes";
        if (msg && typeof msg == 'string') msg = "[SN]" + msg;
        if (environment.production != true || isVerbose) console.log(msg, optionalParams);
    }

    getQueryVariable(variable, decode:boolean = true) {
        var url = window.location.href;
        var query =  url.substring(url.indexOf('?') + 1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var tokens = vars[i].split('=');
            if (decodeURIComponent(tokens[0]).toLowerCase() == variable.toLowerCase()) {
                tokens.shift(); // remove variable element and kept the rest 
                return decode ? decodeURIComponent(tokens.join('=')) : tokens.join('=');
            }
        }
        return "";
    }

    isIOSDevice() {
        return !!navigator.userAgent && /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/session.service.ts